import React, {useCallback, useEffect, useState} from 'react';
import eventBus from "infrastructure/common/eventBus";
import Loading from "./Loading";
import {LoadingEvents} from "./LoadingEvents";

export const LoadingContainer = (props) => {
  const [show, forceUpdate] = useState(false);

  const openFn = useCallback(() => {
    forceUpdate(true);
  }, [forceUpdate]);

  const closeFn = useCallback(() => {
    forceUpdate(false);
  }, [forceUpdate]);

  useEffect(() => {
    eventBus.on(LoadingEvents.OPEN, openFn);
    eventBus.on(LoadingEvents.CLOSE, closeFn);

    return () => {
      eventBus.remove(LoadingEvents.OPEN, openFn);
      eventBus.remove(LoadingEvents.CLOSE, closeFn);
    };
  });

  return (
    <>
      {show && <Loading/>}
    </>
  );
};

LoadingContainer.propTypes = {}

LoadingContainer.defaultProps = {}

export default React.memo(LoadingContainer);
